import {
  type GetBypassQueryResponse,
  useGetUrlAndApplicationBypass,
} from './useGetUrlAndApplicationBypass'

interface GetBypassPageDataQueryProps {
  policyName: string
}

export const useGetBypassPageData = ({
  policyName,
}: GetBypassPageDataQueryProps): GetBypassQueryResponse => {
  return useGetUrlAndApplicationBypass({
    policyName,
  })
}
